module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var corner = [0,2,4,6,8,10,15,20];

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Border</span></div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-2 prop-sublabel\">\r\n            Color\r\n        </div>\r\n        <div class=\"col-md-10\" >\r\n            <input type=\"color\" id=\"borderColorPicker\" name=\"borderColorPicker\" value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.borderColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input type=\"text\" id=\"borderColor\" name=\"borderColor\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.borderColor ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n    <div id=\"prop-column-border-radius\" class=\"row hide\">\r\n        <div class=\"col-md-2 prop-sublabel\">Corner Radius</div>\r\n        <div class=\"col-md-10\"  >\r\n            <select name=\"cornerRadius\" id=\"cornerRadius\" style=\"width: 60px;\" class=\"style-font\">\r\n                ")
    ;  for (var i = 0; i < corner.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(corner[i]))
    ; __append("\">")
    ; __append(escapeFn(corner[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n            </select>\r\n        </div>\r\n    </div>\r\n")
  }
  return __output;

}